import { render, staticRenderFns } from "./RegisterType.vue?vue&type=template&id=496d0d10&scoped=true"
import script from "./RegisterType.vue?vue&type=script&lang=js"
export * from "./RegisterType.vue?vue&type=script&lang=js"
import style0 from "./RegisterType.vue?vue&type=style&index=0&id=496d0d10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496d0d10",
  null
  
)

export default component.exports